import React from "react";
import { FormText } from "reactstrap";
import { LabSelector as BaseLabSelector } from "../LabSelector";
import { InputWrapper, serializeInput } from "./InputWrapper";

export const LabSelector = ({ children, input, label, meta, inputId, ...rest }) => {
  const invalid = Boolean(meta.touched && meta.error);

  return (
    <InputWrapper testId={inputId || rest["data-testid"]} label={label} required={rest.required} htmlFor={inputId}>
      <BaseLabSelector {...input} {...rest} inputId={inputId} valid={!invalid} />

      {meta.touched && meta.error && <FormText color="danger">{meta.error}</FormText>}

      {children}
    </InputWrapper>
  );
};

export const SerializedLabSelector = serializeInput(LabSelector);
